import React from "react";
import { useTranslation } from "react-i18next";
import { formatPhone } from "../../../../utils/methods";

interface BasicDetailsProps {
  email: string
  firstName: string
  lastName: string
  active: boolean
  countryCode: string
  phoneNumber: string
  createdAt: string
}

const BasicDetails: React.FC<BasicDetailsProps> = ({ firstName, lastName,  email, active, countryCode, phoneNumber, createdAt }) => {
  const { t } = useTranslation();

  return (
    <div className="card mb-6 h-100">
      <div className="card-body">
        <small className="card-text text-uppercase text-muted small">
          {t("users.profile.pageTexts.about")}
        </small>
        <ul className="list-unstyled my-3 py-1 mb-7">
          <li className="d-flex align-items-center mb-4">
            <i className="ri-user-3-line ri-24px"></i>
            <span className="fw-medium mx-2">{t("users.profile.pageTexts.firstName")}:</span>
            <span>{firstName}</span>
          </li>
          <li className="d-flex align-items-center  mb-4">
            <i className="ri-user-3-line ri-24px"></i>
            <span className="fw-medium mx-2">{t("users.profile.pageTexts.lastName")}:</span>
            <span>{lastName}</span>
          </li>
          <li className="d-flex align-items-center mb-2">
            <i className="ri-check-line ri-24px"></i>
            <span className="fw-medium mx-2">{t("users.profile.pageTexts.status")}:</span>
            <span>{active ? t("users.profile.pageTexts.active") : t("users.profile.pageTexts.inActive")}</span>
          </li>
          <li className="d-flex align-items-center mb-2">
            <i className="ri-calendar-line ri-24px"></i>
            <span className="fw-medium mx-2">{t("users.profile.pageTexts.joined")}:</span>
            <span>{createdAt}</span>
          </li>
        </ul>
        <small className="card-text text-uppercase text-muted small">
          {t("users.profile.pageTexts.contact")}
        </small>
        <ul className="list-unstyled my-3 py-1">
          <li className="d-flex align-items-center mb-4">
            <i className="ri-phone-line ri-24px"></i>
            <span className="fw-medium mx-2">{t("users.profile.pageTexts.contact")}:</span>
            <span>{phoneNumber ? formatPhone(countryCode, phoneNumber) : '-'}</span>
          </li>
          <li className="d-flex align-items-center mb-2">
            <i className="ri-mail-open-line ri-24px"></i>
            <span className="fw-medium mx-2">{t("users.profile.pageTexts.email")}:</span>
            <span>{email}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BasicDetails;